import { Media, Texts, Button } from "../Object";
import { Grid, Space } from "../Layout";
import { useState, useEffect, useMemo, useRef } from "react";
import { useDocumentLoadCompleted, useInterval, useOffsetTop, useScroll } from "../Hooks";
import { Scroll } from '../Animation';
import { useSwipeable } from 'react-swipeable';

import { About } from '../Project/';

const Fv = () => {
  const [viewIndex, setViewIndex] = useState(0);
  let delay = 8000;
  const isLoaded = useDocumentLoadCompleted();
  const scrollPosition = useScroll();
  
  // カウンター関数
  const CounterStart = useInterval(() => {
    // console.log(viewIndex);
    if(scrollPosition < window.innerHeight) {
      let index = viewIndex; // indexを取得
      let maxNum = 2; // indexの最高値
      if (index == maxNum) {
        // 現在のindexが最高値だった場合、indexを0に戻す
        index = 0; // indexの初期化
      } else {
        index = index + 1; // indexの増加
      }
      setViewIndex(index); // stateに登録
    }
  }, delay);

  useEffect(() => {
    // 全ての要素をロードした後にカウンター開始
    if (isLoaded) {
      CounterStart;
    }
  }, [isLoaded]);
  
  const swipeHandlers = useSwipeable({
    onSwipedRight: (e) => {
      // console.log('right')
      if(viewIndex == 0) {
        setViewIndex(2);
      } else {
        setViewIndex(viewIndex - 1);
      }
      CounterStart;
    },
    onSwipedLeft: (e) => {
      // console.log('left')
      if(viewIndex == 2) {
        setViewIndex(0);
      } else {
        setViewIndex(viewIndex + 1);
      }
      CounterStart;
    },
    onSwiping: (e) => {
    },
    trackMouse: true,
  })

  // elment
  const CatchCopy = (props) => {
    return (
      <>
        {props.index == viewIndex && 
          <div className="c-fv__wrap--text">
            <Texts slug={`catch/list${props.index}`} class="c-fv__text--bottom c-text--white"></Texts>
          </div>
        }
      </>
    );
  };
  
  let CatchCopyItems = [];
  for (let i = 0; i < 3; i++) {
    CatchCopyItems.push(<CatchCopy key={i} index={i}></CatchCopy>)
  }
  const catchCopyItemsMemo = useMemo(() => CatchCopyItems, [viewIndex]);

  // First View Image Elements
  const FvItem = (props) => {
    let active = "";
    if (viewIndex == props.index && isLoaded) {
      active = "active";
    } else {
      active = "anactive";
    }
    return (
      <>
        <li className="c-fv__items" data-state={active}>
          {/* { CatchCopyItems } */}
          <Media
            class="c-fv__img--main"
            src={`FV/fv-main-list${props.index}`}
            alt="fv"
            sp="sp"
          ></Media>
        </li>
      </>
    );
  };
  let fvItems = [];
  for (let i = 0; i < 3; i++) {
    fvItems.push(<FvItem key={i} index={i}></FvItem>);
  }
  const fvItemsMemo = useMemo(() => fvItems, [viewIndex, isLoaded]);
  

  return (
    <>
      <div className="p-box__wrap--top">

        
        <div className="c-fv__wrap">
          <ul className="c-fv__list" {...swipeHandlers}>
            { fvItemsMemo }
          </ul>
        </div>

        <Space size={['120px', '80px']}></Space>
        <div className="l-row">
          <div className="c-grid__wrap--fix">
            <div className="c-fv__sticky__wrap">
              <Sticky type="top" items={catchCopyItemsMemo} />
              <Sticky type="hidden" items={catchCopyItemsMemo} />
              <Sticky type="bottom" items={catchCopyItemsMemo} />
            </div>
            <About />
          </div>
        </div>
      </div>
    </>
  );
};

export default Fv;


export const Sticky = (props) => {
  const stickyRef = useRef();
  const stickyWrapRef = useRef();

  const stickyWrapOffset = useOffsetTop(stickyWrapRef);
  const stickyOffset = useOffsetTop(stickyRef);
  const [isActive, setIsActive] = useState(false);
  const [isMove, setIsMove] = useState(false);
  const isLoaded = useDocumentLoadCompleted();

  useEffect(() => {
    // console.log(window.pageYOffset);
    // console.log('viewportBottom:  ' + stickyWrapOffset.viewportBottom)
    // console.log('window height:  ' + window.innerHeight);
    if (window.innerHeight < 120 + stickyWrapOffset.viewportTop + stickyOffset.pageOffsetBottom - stickyOffset.pageOffsetTop) {
      setIsMove(true);
      setIsActive(false);
    } else {
      setIsMove(false);
      setIsActive(true);
    }
  }, [stickyOffset]);

  return (
    <>
      <div
        ref={stickyWrapRef}
        className={
          isActive ? "c-fv__sticky c-fv__sticky--active" : "c-fv__sticky"
        }
        data-state={props.type}
      >
        <div
          ref={stickyRef}
          className={`c-fv__sticky--inner 
          ${ isLoaded ? " c-fv__sticky--inner--start" : "" }
          ${ isMove ? ' c-fv__sticky--inner--active' : ''}
          `}
          data-state={props.type}
        >
          {props.items}
          {props.type == "bottom" ? (
            <video
              className={`c-fv__img--sticky__top`}
              autoPlay
              muted
              playsInline
              loop
              src={
                tmp_path.temp_uri +
                "/dist/assets/images/common/text-back-movie.mp4"
              }
            ></video>
          ) : (
            <div
              className={`c-fv__img--sticky__top`}
              data-state={props.type}
            ></div>
          )}
          <div
            className={`c-fv__img--sticky__bottom`}
            data-state={props.type}
          ></div>
        </div>
      </div>
    </>
  );
};